module.exports = __webpack_public_path__ + "static/media/IMG_2674.31e14924.jpg";